import { Stack, Typography } from '@mui/material';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';
import { sessionCategoriesFilter } from 'reducer/CompassRights/EntitlementsReducer';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IClearFilters {
  setFilteredCategories: Function;
}

export const ClearFilters = ({ setFilteredCategories }: IClearFilters) => {
  const { categories, dispatchCategories, entitlements, dispatchEntitlements } =
    useContext(EntitlementsContext);

  const FilterClearHandler = () => {
    sessionStorage.removeItem(sessionCategoriesFilter);
    dispatchCategories({
      type: 'INITIALIZATION',
      payload: { value: categories },
    });
    setFilteredCategories([]);
    dispatchEntitlements({
      type: 'INITIALIZATION',
      payload: { value: entitlements.allEntitlements },
    });
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='4px'
      width='fit-content'
      onClick={FilterClearHandler}
      onKeyDown={(event) => onEnterOrEscapeKeyDown(event)}
      tabIndex={0}
      sx={{ cursor: 'pointer' }}
    >
      <Typography
        variant={'body1'}
        whiteSpace='nowrap'
        color={'primary.main'}
        sx={{ textDecoration: 'underline' }}
      >
        {Dictionary[DICTIONARY.CompassRights].clearSelection}
      </Typography>
    </Stack>
  );
};
